import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup,Validators } from '@angular/forms';
import { AuthService } from 'src/app/service/auth.service';
import { TokenStorageService } from 'src/app/service/token-storage.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {

  isShowPass = false;

  handleShowPass () {
    this.isShowPass = !this.isShowPass;
  }

  public registerForm!: FormGroup;
  public formSubmitted = false;

  constructor(
    private toastrService: ToastrService,
    private authApi: AuthService,
    private tokenStorage:TokenStorageService,
    private router: Router,
  ) { }

  ngOnInit () {
    this.registerForm = new FormGroup({
      first_name:new FormControl(null,[Validators.required]),
      last_name:new FormControl(null,[Validators.required]),
      email:new FormControl(null,[Validators.required,Validators.email]),
      password:new FormControl(null,[Validators.required,Validators.minLength(6)]),
      password_confirmation:new FormControl(null,[Validators.required,Validators.minLength(6)]),
    })
  }

  onSubmit(data:any) {
    this.formSubmitted = true;
    if (this.registerForm.valid) {
      this.authApi.register(data).subscribe({
        next:(res:any) => {
          this.registerForm.reset();
          this.formSubmitted = false; // Reset formSubmitted to false
          this.tokenStorage.saveToken(res.token);
          this.tokenStorage.saveUser(res.user);
          this.toastrService.success(res.massage);
          this.router.navigate(['/account'])
        },
        error:(err) => {
          this.toastrService.error(err.massage);
        },
      })
    }
  }

}
